import { useEffect } from 'react';
import axios from 'axios';

export function useFetchStoreLocations(setStoreLocation, fetchStoreLocation, setfetchStoreLocation, storePage) {
  useEffect(() => {
    if (fetchStoreLocation !== 'fetched') {
      const fetchStores = async () => {
        try {
          const response = await axios.get('/server/ikea_services_function/storelist', {
            params: { page: storePage, perPage: 200 },
          });

          const {
            data: { StoreList },
          } = response.data;

          setStoreLocation(StoreList);
          setfetchStoreLocation('fetched');
        } catch (err) {
          console.error(err);
          setfetchStoreLocation('error');
        }
      };

      fetchStores();
    }
  }, [fetchStoreLocation, storePage]);
}
